export const ORGANIZATION_ID = 'selected_org_id';
export const ORGANIZATION_SETTINGS = 'organizationSettings';
